import { fetchActivateFailure, fetchActivateSucess } from "./reducer"
import { toast } from "react-toastify";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { ACTIVATE } from "../../constants/constants";
import { getAllUser } from "../thunk";

export const activateUser = (userId, setLoading, location, operatorIdFromOptions) => async (dispatch) => {
    setLoading(true)
    await determineBaseUrlAndPerformApiCall(`user/${userId}/${ACTIVATE}`, 'POST').then((response) => {
        if (!response.error) {
            dispatch(fetchActivateSucess(response))
            setLoading(false)
            toast.success(` User Activated Successfully`)
            const roleName = localStorage.getItem("roleName")
            const isInView = location?.pathname?.includes('view-operator')
            let operatorId
            if (roleName === "systemUser") {
                if (isInView) {
                    operatorId = operatorIdFromOptions
                }
            }
            else {
                operatorId = localStorage.getItem("operatorId")
            }
            dispatch(getAllUser(setLoading, operatorId, location))
        }
        if (response.error) {
            dispatch(fetchActivateFailure(response.error.message))
            setLoading(false)
            toast.error(`${response.error.message}`)
        }
    })
}